import Localize from "../localization";

export default class ErrorMessage extends Error {
  constructor(name, message, status, code, id, details, ...params) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(details, ...params);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ErrorMessage);
    }

    this.name = name;
    this.message = message;
    this.details = details;
    this.status = status;
    this.code = code;
    this.id = id;
    this.date = new Date();
  }

  /**
   * Get the localized error description using the priority system:
   * 1. Specific localized error using ERROR_ID.{clientType}
   * 2. Generic API error message from backend
   * 3. Fallback to unexpected error message
   *
   * @returns {string} Localized error description
   */
  getLocalizedDescription() {
    // Priority 1: Try to get specific localized error using the client type ID
    if (this.id) {
      try {
        const localizedError = Localize(`ERROR_ID.${this.id}`);
        // Check if localization returned a valid string (not the key itself or error indicators)
        if (
          localizedError &&
          typeof localizedError === "string" &&
          localizedError !== `ERROR_ID.${this.id}` &&
          !localizedError.includes("No locale found")
        ) {
          return localizedError;
        }
      } catch (e) {
        // Silently continue to next priority
      }
    }

    // Priority 2: Use the generic error message from the API
    if (this.message && typeof this.message === "string") {
      return this.message;
    }

    // Priority 3: Fallback to unexpected error
    try {
      return Localize("ERROR_ID.UNEXPECTED");
    } catch (e) {
      // Ultimate fallback if even the unexpected error localization fails
      return "An unexpected error occurred. Try again or contact support.";
    }
  }
}
